export var AFREECATV_DOMAIN = "onlive.vn";
export var BJAPI_ROOT_URL = "//bjapi.onlive.vn/api";
export var AFREECATV_URL = "//www.onlive.vn";
export var BJ_AFREECA_URL = "//streamer.onlive.vn";
export var LOGIN_URL = "https://login.onlive.vn";
export var LOGOUT_URL = "https://login.onlive.vn/app/LogOut.php";
export var SEARCH_API_URL = "//scketc.onlive.vn/api.php";
export var AFEVENT2_8120 = "https://afevent2.onlive.vn";
export var AFEVENT2_SSL = "https://afevent2.onlive.vn";
export var INFO_URL = AFEVENT2_SSL + "/api/get_private_info.php";
export var FAVORITE_URL = "//my.onlive.vn/favorite";
export var USER_INFO_URL = "https://member.onlive.vn/app/user_info.php";
export var MY_REVENUE_URL = "https://myrevenue.onlive.vn/";
export var EVENTAPI_NONE_SCHEME = "//eventapi.onlive.vn";
export var CLICK_LOG_URL = EVENTAPI_NONE_SCHEME + "/set_log_api.php";
export var MEMBER_NONE_SCHEME = "//member.onlive.vn";
export var DASHBOARD = "http://dashboard.onlive.vn";
export var PROFILE_IMG_URL = "//profile.img.onlive.vn";
export var STIMG_URL = "//stimg.onlive.vn";
export var RES_AFREECATV_URL = "//res.onlive.vn";
export var VTVLIVE_URL = "https://www.vtvlive.vn/";
export var SUPPORT_URL = "https://hotro.onlive.vn";
export var POINT_URL = "https://point.onlive.vn";